import { defineMessages } from 'react-intl';

export const approvalHistoryMessages = defineMessages({
  resolvedBy: {
    defaultMessage:
      '<statusStyle>{status, select, approved {approved} denied {denied} timed_out {timed out} other {resolved}}</statusStyle><resolver>by {name}</resolver>',
    id: 'KDL90Jc9qp',
    description: 'Approval history line showing its status and who resolved it',
  },
  status: {
    defaultMessage:
      '{status, select, approved {approved} denied {denied} timed_out {timed out} other {resolved}}',
    id: '0i7ckwI4/O',
    description: 'Approval history status when no resolver name is available',
  },
});
